// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3_zFm","title":"Header_title__2bDy8","side":"Header_side__27Rhp"};